import React, { Component, createRef } from 'react';

import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { RouterState } from 'redux-first-history';
import { isEmpty } from 'lodash-es';

import Auth from '../../Authentication';
import { ApplicationState as State } from '../../../store';
// import Loader from '../../PageLoader';
import { LocationHistoryState } from '../../../store/locationHistory/types';
import LayoutSrc from './layout.html';

type LegacyDashRouteType = {
    router: RouterState;
    locationHistory: LocationHistoryState;
};

type LegacyDashRouteStateType = {
    isLoading: boolean;
};

const CDN_PATH = LEGACY_EE_BUNDLE;

const mapState = (state: State): LegacyDashRouteType => {
    return {
        router: state.router,
        locationHistory: state.locationHistory,
    };
};

class LegacyDashRoute extends Component<LegacyDashRouteType, LegacyDashRouteStateType> {
    private template = LayoutSrc;

    private iFrameRef = createRef<HTMLIFrameElement>();

    private timeoutId: any;

    public constructor(props) {
        super(props);

        const bundlePath = `${CDN_PATH}/1.0/emailinterface.js`;
        const cssPath = `${CDN_PATH}/1.0/emailinterface.css"`;
        const apiPath = `${APIPATH}`;
        this.template = this.template.replace('{{BUNDLE_PATH}}', bundlePath);
        this.template = this.template.replace('{{CSS_PATH}}', cssPath);
        this.template = this.template.replace('{{apiPath}}', apiPath);

        this.state = {
            isLoading: true,
        };

        if (props?.locationHistory?.previousLocation?.pathname) {
            sessionStorage.setItem(
                'prevPath',
                `${props.locationHistory.previousLocation.pathname}${props.locationHistory.previousLocation.search}`
            );
        }
    }

    public componentDidUpdate(prevProps: LegacyDashRouteType): void {
        if (prevProps?.router?.location?.hash !== this.props?.router?.location?.hash) {
            // @ts-expect-error ee global object
            this.iFrameRef.current.contentWindow.window.ee.goTo(this.props.router.location.hash);
        }
    }

    public componentDidMount(): void {
        this.isLegacyDashLoaded();
    }

    private isLegacyDashLoaded(): void {
        this.timeoutId = setTimeout(() => {
            sessionStorage.setItem('key', Auth.getAccessToken());
            const iFrameWindow = this.iFrameRef?.current?.contentWindow?.window;

            // @ts-expect-error ee global object
            if (iFrameWindow?.ee && !isEmpty(iFrameWindow?.ee?.data) && !isEmpty(iFrameWindow?.ee?.data?.account)) {
                clearTimeout(this.timeoutId);

                // @ts-expect-error ee global object
                iFrameWindow.ee.indiOn();
                setTimeout(() => {
                    // @ts-expect-error ee global object
                    iFrameWindow.ee.indiOff();
                }, 2000);

                this.setState({ isLoading: false });

                return;
            }

            this.isLegacyDashLoaded();
        }, 100);
    }

    public render(): JSX.Element {
        return (
            <>
                {/* {this.state.isLoading && <Loader />} */}
                <iframe
                    ref={this.iFrameRef}
                    referrerPolicy="unsafe-url"
                    title="legacyDash"
                    srcDoc={this.template}
                    style={{
                        border: 'none',
                        height: '99vh',
                    }}
                    width="100%"
                />
            </>
        );
    }
}

export default compose(connect<LegacyDashRouteType>(mapState))(LegacyDashRoute);
